import React from "react";
import Link from "next/link";

export default function Topbar({ websiteData }) {
  return (
    <div className="w-full relative z-20 bg-transparent shadow-sm">
      <section className="bg-[#314823]">
        <div className="container mx-auto flex items-center justify-between gap-4 py-2 sm:py-3">
          <Link href="/" passHref className="shrink-0">
            <img
              src={websiteData?.website?.logo}
              alt="School Logo"
              width={250}
              height={64}
              style={{"maxWidth":"250px"}}
              className="cursor-pointer"
              loading="eager"
              decoding="async"
            />
          </Link>

          <div className="hidden items-center gap-6 md:flex">
            <div className="flex items-center">
              <div className="mr-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#f1bb62]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#334821]"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-white">Call</p>
                <Link
                  href={`tel:${websiteData?.website?.contactNumber?.[0]}`}
                  className="text-sm text-gray-200 hover:text-white hover:underline"
                >
                  {websiteData?.website?.contactNumber?.[0]}
                </Link>
                <span className="text-white">,</span>
                {websiteData?.website?.contactNumber?.[1] && (
                  <Link
                    href={`tel:${websiteData?.website?.contactNumber?.[1]}`}
                    className="mx-1 text-sm text-white hover:text-white hover:underline"
                  >
                    {websiteData?.website?.contactNumber?.[1]}
                  </Link>
                )}
              </div>
            </div>

            <div className="flex items-center">
              <div className="mr-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#f1bb62]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#334821]"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-white">Address</p>
                <p className="text-sm text-gray-200">
                  {websiteData?.website?.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
